import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { AdriverBannerId } from '@/components/Banners/Banners.constants';
import { BannerName } from '@/components/Banners/Banners.types';

export function useAdriverBgBannerCleaner() {
  const pathname = usePathname();

  useEffect(() => {
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (
              node instanceof HTMLElement &&
              (node.classList.contains('lotriver-bg-left') ||
                node.classList.contains('lotriver-bg-right'))
            ) {
              const bannerElement = document.getElementById(
                AdriverBannerId[BannerName.Background]
              );

              if (!bannerElement) {
                node.remove();
              }
            }
          });
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: false,
    });

    return () => observer.disconnect();
  }, [pathname]);
}
